import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    name: '张三',
    number: 0,
  },
  mutations: {
    // 增加nutations属性
    setNumber(state) {
      // 增加一个mutations的方法，方法的作用是让num从0变成5，state是必须默认参数
      state.number = 5;
    },
    setNumberIsWhat(state, number) {
        // 增加一个带参数的mutations方法
        state.number = number;
      },
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js